import React from 'react';
import './commonStyle.css';

/**
 * Button - Modal action button used in login modals and AlertModal.
 *
 * Props:
 * - onClick: function - click handler
 * - buttonText: string - button label
 * - className: string - additional CSS classes
 */
const Button = ({ onClick, buttonText, className = '' }) => (
  <button
    className={`modal-btn ${className}`}
    onClick={onClick}
  >
    {buttonText}
  </button>
);

export default Button;
